import React from 'react';
import { ToolbarIcon } from '@instinet-analytics/semantic-ui-components';
import { SizeToContentsInput } from 'utils/components/SizeToContentsInput/SizeToContentsInput';
import FilterLabel from 'utils/components/FilterLabel/FilterLabel';
import './QuickSearch.scss';

export interface QuickSearchProps {
    filterApplied: boolean;
    filteredRowCount: number;
    placeholder?: string;
    searchText: string;
    onSearchChange: (nextSearch: string) => void;
}

function QuickSearch(props: QuickSearchProps) {
    const {
        filterApplied,
        filteredRowCount,
        searchText,
        onSearchChange,
        placeholder,
    } = props;

    const quickSearchApplied = !!searchText;

    return (
        <div className="QuickSearch">
            <ToolbarIcon name="search" disabled={true} />

            <SizeToContentsInput
                value={searchText}
                placeholder={placeholder}
                onValueChange={onSearchChange}
            />
            {quickSearchApplied && (
                <FilterLabel
                    filterApplied={filterApplied}
                    filteredRowCount={filteredRowCount}
                />
            )}
        </div>
    );
}

export default React.memo(QuickSearch);
